import { useState, useNuxtApp } from "nuxt/app";
export const useCurrentShop = () => {
  const nuxt = useNuxtApp();
  return useState(
    "currentShop",
    () => nuxt.$currentShop
  );
};
